'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-google-charts/~/react/react.js
// module id = 1109
// module chunks = 0